import panguInputNumberForPercent from './panguInputNumberForPercent.vue'
export default panguInputNumberForPercent
